module.exports = __webpack_public_path__ + "img/diamonds-with@2x.848f018.webp";